import styled from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const FullPageLoader = styled.div`
  width: 100svw;
  height: 100svh;
`;
